<!-- Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved. -->
<div *ngIf="show" id="backdrop" class="backdrop" (click)="show = false"></div>

<span matTooltipShowDelay="500" id="show-hide-columns" matTooltip="Show/hide columns displayed" matTooltipPosition="left" class="mdi mdi-table-of-contents" (click)="show = !show"></span>

<div class="menu-container">
  <div class="modify-cols mat-elevation-z8" [ngClass]="{'hidden': !show}">
      <div *ngFor="let element of elements">
          <div class="element" *ngIf="!element.hidden" (click)="elementChanged(element)" [ngClass]="element.selected ? 'element-selected' : ''">
              <span *ngIf="element.selected" id="checked_checkbox_{{element.value}}" class="mdi mdi-checkbox-marked"> </span>
              <span *ngIf="!element.selected" id="empty_checkbox_{{element.value}}" class="mdi mdi-checkbox-blank-outline"> </span>
              <span> {{element.title}} </span>
          </div>
      </div>
  </div>
</div>